var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"preview-phone"},[_c('div',{staticClass:"phone-header"},[_c('globalFunctional',{attrs:{"theme":"dark","data":_vm.data},on:{"setGlobal":_vm.setGlobal}})],1),_c('div',{staticClass:"phone-main"})])
}
var staticRenderFns = []

export { render, staticRenderFns }